<template>
  <!-- NOTE (TEMPLATE) to get information and add new reviewer -->

  <div class="animated fadeIn">
    <span v-show="false">{{ reactivity }}</span>
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/admin/addReviewer'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2>افزودن داور جدید</h2>

      <hr />

      <b-form-group label="تلفن همراه">
        <b-form-input
          trim
          type="number"
          :no-wheel="true"
          v-model="profile.mobile"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="نام">
        <b-form-input trim type="text" v-model="profile.name"></b-form-input>
      </b-form-group>
      <b-form-group label="نام خانوادگی">
        <b-form-input
          trim
          type="text"
          v-model="profile.lastName"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="پست الکترونیکی">
        <b-form-input
          trim
          type="text"
          v-model="profile.email"
          :state="validateEmail(profile.email) ? null : false"
          aria-describedby="email"
        ></b-form-input>
        <b-form-invalid-feedback id="email"
          >پست الکترونیک صحیح نیست</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group description label="استان:">
        <v-autocomplete
          v-model="profile.stateId"
          :items="iran"
          @change="profile.cityId = ''"
          item-value="id"
          item-text="name"
          dense
          outlined
          class="dropdown-style"
          hide-details
        ></v-autocomplete>
      </b-form-group>

      <b-form-group description label="شهر:">
        <v-autocomplete
          v-model="profile.cityId"
          :items="
            iran.filter((x) => x.id == profile.stateId).map((y) => y.cities)[0]
          "
          item-value="id"
          item-text="name"
          dense
          outlined
          class="dropdown-style"
          hide-details
        ></v-autocomplete>
      </b-form-group>
      <b-row class="mb-2">
        <b-col>
          <span
            class="select-text"
            :class="
              profile.universityId
                ? profile.universityId != notUniversity
                  ? 'done'
                  : otherUniversity
                  ? 'done'
                  : 'required'
                : 'required'
            "
            >دانشگاه</span
          >
        </b-col>
        <b-col class="text-left">
          <b-form-checkbox
            id="checkbox-1"
            v-model="profile.universityId"
            name="checkbox-1"
            :value="notUniversity"
            unchecked-value=""
            @change="reactivity = !reactivity"
          >
            سایر دانشگاه ها
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-form-group>
        <v-autocomplete
          v-model="profile.universityId"
          :items="universities"
          item-value="id"
          item-text="text"
          dense
          outlined
          class="dropdown-style"
          hide-details
          :disabled="profile.universityId == notUniversity"
        ></v-autocomplete>

        <b-form-input
          trim
          class="mt-1"
          v-model="profile.otherUniversity"
          v-show="profile.universityId == notUniversity"
          placeholder="نام دانشگاه مورد نظر"
          @input="reactivity = !reactivity"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="رشته تحصیلی">
        <b-form-input trim type="text" v-model="profile.field"></b-form-input>
      </b-form-group>
      <b-form-group label="کدملی">
        <b-form-input
          trim
          type="number"
          v-model="profile.natCode"
          :state="checkCodeMeli(profile.natCode) ? null : false"
          aria-describedby="natCode"
        ></b-form-input>
        <b-form-invalid-feedback id="natCode"
          >کد ملی درست نیست</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group label="آخرین مدرک تحصیلی">
        <b-form-select
          v-model="profile.lastDegree"
          :options="eduGradeOptions"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="برچسب‌های داور">
        <b-form-tags
          tag-variant="primary"
          tag-pills
          placeholder="برچسب اضافه کنید"
          input-id="tags-basic"
          addButtonText="افزودن"
          v-model="profile.tags"
        ></b-form-tags>
      </b-form-group>

      <div class="d-flex justify-content-center">
        <!-- NOTE (b-addReviewer) to confirm the addition of a new reviewer -->
        <b-button
          variant="success"
          class="mx-2"
          @click="addReviewer()"
          :disabled="
            isBusy ||
            validateEmail(profile.email) == false ||
            checkCodeMeli(profile.natCode) == false ||
            !(profile.name && profile.mobile)
          "
          >ثبت</b-button
        >
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import utilities from "../../mixins/utilities"; // REVIEW

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
  },
  mixins: [utilities], // REVIEW
  data() {
    return {
      reactivity: false,
      profile: {
        tags: [],
      },
      universities: [],
      otherUniversity: "",
      iran: [],
      eduGradeOptions: ["کارشناسی", "کارشناسی ارشد", "دکتری", "دکتری حرفه ای"],
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      states: [
        { value: "active", text: "فعال" },
        { value: "deactive", text: "غیرفعال" },
      ],

      fileFilter: "",
      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "project_code", label: "کد طرح" },
        { key: "register_date", label: "تاریخ ثبت" },
        { key: "project_status", label: "وضعیت" },
        { key: "university", label: "دانشگاه" },
        { key: "last_update", label: "آخرین بروزرسانی" },
      ],
      // items: [{ faSubject: 'test1' , project_status: 'نیاز به تکمیل'}, { faSubject: 'test2', project_status: 'ثبت شده' }],
      items: [],
      filter: "",
      isBusy: false,
      isLoaded: true,
    };
  },

  methods: {
    addReviewer() {
      // NOTE (m-addReviewer) to add new reviewer
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reviewer/new",
          {
            name: this.profile.name,
            lastName: this.profile.lastName,
            mobile: this.profile.mobile,
            lastDegree: this.profile.lastDegree,
            email: this.profile.email,
            stateId: this.profile.stateId ? this.profile.stateId : null,
            cityId: this.profile.cityId ? this.profile.cityId : null,
            universityId: this.profile.universityId,
            otherUniversity:
              this.profile.universityId == this.notUniversity
                ? this.profile.otherUniversity
                : "",
            field: this.profile.field,
            natCode: this.profile.natCode,
            tags: this.profile.tags,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.isBusy = false;
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.$router.push("/admin/reviewers");
          } else if (res.status == 202) {
            this.toast(res.data.text, "success");
            this.toast(res.data.error, "error");
            this.$router.push("/admin/reviewers");
          }
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.isBusy = false;

          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/options/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    onMounted() {
      // NOTE (MOUNTED) to show the list of universitys with dropdown
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data.map((x) => {
            return {
              id: x.id,
              text: x.text,
            };
          });
          this.universities.push(
            new Object({
              id: 1,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },

  mounted() {
    this.getStatesAndCities();
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
